import {useCallback, useState} from 'react';
import EventListener from 'react-event-listener';

import ComputeStyle from './ComputeStyle';

const ScrollDirection = {
    vertical: 'vertical',
    horizontal: 'horizontal',
};

const ScrollWatch = ({verticalElement = window, horizontalElement = window, children}) => {
    const [scrollDirection, setScrollDirection] = useState(ScrollDirection.vertical);
    const handleVerticalScroll = useCallback(() => setScrollDirection(ScrollDirection.vertical), []);
    const handleHorizontalScroll = useCallback(() => setScrollDirection(ScrollDirection.horizontal), []);

    return (
        <EventListener target={verticalElement} onScroll={handleVerticalScroll}>
            <EventListener target={horizontalElement} onScroll={handleHorizontalScroll}>
                {children(scrollDirection)}
            </EventListener>
        </EventListener>
    );
};

export {ScrollDirection, ComputeStyle};

export default ScrollWatch;
